import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

class ResultsContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    const { history } = this.props;

    history && history.push("/");
  }

  render() {
    const {} = this.props;

    return <div />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const mapStateToProps = (state, ownProps) => {
  return {};
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ResultsContainer);
